// @flow

import {observable, action} from 'mobx'

class AnnosjakeluStore {
  @observable filteredMedicines: Array<Object> = []
  @observable pagedMedicines: Array<Object> = []
  @observable activePage: number = 1
  @observable isFetching: boolean = false
  @observable footerLabels: Object = {}
  @observable settings: Object = {}

  @action
  saveFilteredMedicines = (medicines: Array<Object>) => {
    this.filteredMedicines = medicines
  }
  savePagedMedicines = (medicines: Array<Object>) => {
    this.pagedMedicines = medicines
  }
  saveActivePage = (page: number) => {
    this.activePage = page
  }
  saveIsFetching = (is: boolean) => {
    this.isFetching = is
  }
  saveFooterLabels = (footer: Object) => {
    this.footerLabels = footer
  }
  saveSettings = (settings: Object) => {
    this.settings = settings
  }
}

export default new AnnosjakeluStore()



// WEBPACK FOOTER //
// ./src/homepage/store.js